import { apiPatch } from "../client";
import type { ExamSetStatus } from "./types";
import { useMutation } from "@tanstack/react-query";

export interface IExamSetUpdateRequest {
  title?: string;
  description?: string;
  exam_type?: string;
  status?: ExamSetStatus;
  items?: Array<{ exam_paper_id: string; order: number }>;
}

export const apiUpdateExamSet = (id: string, data: IExamSetUpdateRequest) => {
  return apiPatch<{ message: string }>(`/exam_sets/${id}`, data);
};

export const useUpdateExamSet = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: IExamSetUpdateRequest }) =>
      apiUpdateExamSet(id, data),
  });
};

export default useUpdateExamSet;
